import Swal from "sweetalert2";
import { Action } from "../../application/domain/actions";
import { CreateActionUseCase } from "../../application/usecases/create-action.usecase";
import { CreateActionProps } from "./interfaces/create-action.interface";
import { ListActionsUseCase } from "../../application/usecases/list-actions.usecase";
import { ListActionsProps } from "./interfaces/list-actions.interface";
import { urlsPages } from "../../../../common/urls/urls-pages";

export class ActionController {
    static async create(ui: CreateActionProps): Promise<void> {
        try {
            if (!ui.color || !ui.description) {
                Swal.fire({
                    title: "Erro",
                    text: "Por favor, capture a cor e digite a ação",
                    icon: "error",
                });
                return;
            }
            const action = new Action(
                ui.workoutId,
                ui.color,
                ui.description
            );
            ui.setLoad(true);
            const actionCreated = await CreateActionUseCase.execute(action);
            ui.setLoad(false);
            if (actionCreated) {
                action.id = actionCreated.id;
                ui.setActions((prev) => [action, ...prev]);
                ui.setIsModalOpen(false);
            }
        } catch (error) {
            ui.setLoad(false);
            this.showError("Erro ao criar ação");
        }
    }


    static async list(ui: ListActionsProps): Promise<void> {
        try {
            ui.setLoad(true)
            const response = await ListActionsUseCase.execute(ui.workoutId);        
            if (!response.workout){
                this.redirectToInitDrill();
            }
                
            ui.setActions(response.actions);
            ui.setWorkout(response.workout);
            ui.setLoad(false);
        } catch (error) {            
            this.redirectToInitDrill();
        }
    }

    private static showError(msg: string) {
        Swal.fire({
            title: "Erro",
            text: msg,
            icon: "error",
        });
    }

    private static redirectToInitDrill(){
        window.location.href = urlsPages.drills;
    }
}